<template>
  <ul class="contact_list">
    <li v-for="item in items" :key="item.title">
      <component :is="item.href ? 'a' : 'div'" :href="item.href" class="contact_row">
        <span class="contact_icon">
          <component :is="icons[item.icon]" />
        </span>
        <span>
          <span class="contact_title">{{ item.title }}</span>
          <span class="contact_value">{{ item.value }}</span>
        </span>
      </component>
    </li>
  </ul>
</template>

<script>
// Phone / e-mail / address rows, each with a round icon, separated by a rule.
// `items` is [{ icon: 'phone' | 'mail' | 'pin' | 'clock', title, value, href? }].

import PhoneIcon from '@/components/icons/PhoneIcon.vue'
import MailIcon from '@/components/icons/MailIcon.vue'
import PinIcon from '@/components/icons/PinIcon.vue'
import ClockIcon from '@/components/icons/ClockIcon.vue'

export default {
  name: 'SiteContactList',

  props: {
    items: { type: Array, required: true },
  },

  data() {
    return {
      icons: { phone: PhoneIcon, mail: MailIcon, pin: PinIcon, clock: ClockIcon },
    }
  },
}
</script>

<style scoped>
.contact_list li + li {
  border-top: 1px solid var(--paper-line);
}

.contact_row {
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 8px 0;
}

.contact_icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 82px;
  height: 82px;
  flex: none;
  border-radius: 50%;
  color: var(--ink);
  font-size: 42px;
}

.contact_title {
  display: block;
  color: var(--ink-body);
  font-size: 22px;
  font-weight: 700;
  line-height: 1.5;
}

.contact_value {
  display: block;
  color: var(--ink-muted);
}

a.contact_row:hover .contact_value {
  color: var(--accent);
}

@media (max-width: 600px) {
  .contact_icon {
    width: 56px;
    height: 56px;
    font-size: 28px;
  }
}
</style>
